import { render, staticRenderFns } from "./GroupsForm.vue?vue&type=template&id=41414ee2&scoped=true"
import script from "./GroupsForm.vue?vue&type=script&lang=js"
export * from "./GroupsForm.vue?vue&type=script&lang=js"
import style0 from "./GroupsForm.vue?vue&type=style&index=0&id=41414ee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41414ee2",
  null
  
)

export default component.exports